import { updateUser } from 'APIs/AuthApi';
import { getOtherUserData } from 'APIs/UserDataApi';
import Loader from 'components/atoms/loader';
import Footer from 'components/organisms/Footer/GlobalFooter';
import HomeHeader from 'components/organisms/Header/HomeHeader';
import OtherProfileHeader from 'components/organisms/Header/OtherProfileHeader';
import { UserProfileData, UserPlatform } from 'interfaces/UserData.interface';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { uploadFileUtil } from 'utils/Fileupload.utils';
import Error from './Error';
import Body from './ProfilePageBody';

const OtherProfilePage = () => {
  const { username } = useParams();
  const username_lowercase = username?.toLowerCase();
  const [currentTab, setCurrentTab] = React.useState<string>('Feed');
  const [editing, setEditing] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<UserProfileData>({
    name: '',
    username: '',
    email: '',
    address: '',
    walletAddress: '',
    instagram: '',
    twitter: '',
    avatar: '',
    banner: '',
    verified: false,
    website: '',
    facebook: '',
    tiktok: '',
    platform: UserPlatform.CLIENT,
    seenOnBoarding: false,
    canPost: false,
    backstageDesc: '',
    followers: [],
    following: [],
    subscribers: [],
  });

  const toggleEditing = () => {
    setEditing(editing => !editing);
  };

  const handleSubmit = async () => {
    setEditing(false);
    let avatarUrl = data.avatar;
    let bannerUrl = data.banner;
    if (data.avatar) {
      try {
        let file = await fetch(data.avatar)
          .then(r => r.blob())
          .then(
            blobFile =>
              new File(
                [blobFile],
                `${username_lowercase}_avatar_${Date.now()}.png`,
                {
                  type: 'image/png',
                }
              )
          );
        const url = await uploadFileUtil(
          file,
          undefined,
          false,
          true,
          undefined,
          false
        );
        avatarUrl = url;
      } catch (error) {
        // console.error(error)
      }
    }

    if (data.banner) {
      try {
        let file = await fetch(data.banner)
          .then(r => r.blob())
          .then(
            blobFile =>
              new File(
                [blobFile],
                `${username_lowercase}_banner_${Date.now()}.png`,
                {
                  type: 'image/png',
                }
              )
          );
        const url = await uploadFileUtil(file);
        bannerUrl = url;
      } catch (error) {
        // console.error(error)
      }
    }
    await updateUser({ ...data, avatar: avatarUrl, banner: bannerUrl });
  };

  const fetchData = async () => {
    if (!username_lowercase) return;
    const userData = (await getOtherUserData(
      username_lowercase
    )) as UserProfileData;
    setData(data => ({ ...data, ...userData }));
    setLoading(false);
  };

  React.useEffect(() => {
    setLoading(true);
    fetchData();

    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <HomeHeader></HomeHeader>
      {loading ? (
        <div style={{ height: '80vh' }}>
          <Loader />
        </div>
      ) : data.username !== '' ? (
        <>
          {' '}
          <OtherProfileHeader
            setCurrentTab={setCurrentTab}
            currentTab={currentTab}
            toggleEditing={toggleEditing}
            handleSubmit={handleSubmit}
            editing={editing}
            data={data}
            setData={setData}
            fetchData={fetchData}
          />
          <Body editing={editing} data={data} setData={setData} />{' '}
        </>
      ) : (
        <Error />
      )}
      <Footer />
    </React.Fragment>
  );
};

export default OtherProfilePage;
